import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "110%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const FadeUp = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Marquee = ({ items }) => (
  <div className="overflow-hidden border-y border-[#DFE5DC] py-6 select-none bg-white" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center gap-32 pr-32">
          {items.map((t, i) => (
            <span key={i} className="flex items-center gap-32">
              <span className="font-display italic text-2xl md:text-3xl text-[#5C6B62]">{t}</span>
              <span className="h-2 w-2 rotate-45 bg-[#C9A227] shrink-0" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
